const SANITIZE_REGEX = /[./\- ]/g;
const FORMAT_REGEX = /^[A-Z0-9]{12}\d{2}$/;
const ALPHANUMERIC_REGEX = /[A-Z]/;

export function sanitize(raw: string | null | undefined): string {
  if (!raw) return '';
  return raw.replace(SANITIZE_REGEX, '').toUpperCase();
}

export function isAlphanumeric(raw: string | null | undefined): boolean {
  return ALPHANUMERIC_REGEX.test(sanitize(raw));
}

export function format(raw: string | null | undefined): string {
  const clean = sanitize(raw);
  if (clean.length !== 14) return raw || '';
  return `${clean.slice(0, 2)}.${clean.slice(2, 5)}.${clean.slice(5, 8)}/${clean.slice(8, 12)}-${clean.slice(12, 14)}`;
}

export function isValid(raw: string | null | undefined): boolean {
  const clean = sanitize(raw);
  if (clean.length !== 14) return false;
  if (!FORMAT_REGEX.test(clean)) return false;
  if (clean.split('').every(c => c === clean[0])) return false;

  const dv1 = calculateDigit(clean.slice(0, 12));
  if (dv1 !== clean.charCodeAt(12) - 48) return false;

  const dv2 = calculateDigit(clean.slice(0, 13));
  return dv2 === clean.charCodeAt(13) - 48;
}

function calculateDigit(chars: string): number {
  let sum = 0;
  let weight = 2;
  for (let i = chars.length - 1; i >= 0; i--) {
    sum += (chars.charCodeAt(i) - 48) * weight;
    weight = weight === 9 ? 2 : weight + 1;
  }
  const remainder = sum % 11;
  return remainder < 2 ? 0 : 11 - remainder;
}

export const CNPJ_ALPHA_MASK = [
  /[\dA-Za-z]/, /[\dA-Za-z]/,
  '.',
  /[\dA-Za-z]/, /[\dA-Za-z]/, /[\dA-Za-z]/,
  '.',
  /[\dA-Za-z]/, /[\dA-Za-z]/, /[\dA-Za-z]/,
  '/',
  /[\dA-Za-z]/, /[\dA-Za-z]/, /[\dA-Za-z]/, /[\dA-Za-z]/,
  '-',
  /\d/, /\d/,
];
